import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import Icon from './Icon';

interface ButtonPropsBase {
  icon?: IconProp;
  block?: boolean;
  underline?: boolean;
  outline?: string;
  shape?: 'circle' | 'oval';
  size?: number;
  iconPosition?: 'left' | 'right';
}

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & ButtonPropsBase;

function Button({
  icon,
  block,
  underline,
  outline,
  shape,
  size,
  iconPosition = 'right',
  style: propStyle,
  ...rest
}: ButtonProps) {
  const baseStyles: React.CSSProperties = { transition: 'all 0.1s ease-out' };
  const style = { ...propStyle, ...baseStyles };
  const classes = [rest.className];

  if (block) {
    classes.push('w-full');
  }

  if (underline) {
    classes.push('underline');
  }

  if (outline) {
    classes.push('rounded-full');
    classes.push('border');
    classes.push(outline);
    classes.push('font-semibold');
  }

  if (shape === 'circle') {
    classes.push('justify-center');
    classes.push('items-center');
  }

  if (shape === 'oval') {
    classes.push('px-2');
    classes.push('py-1');
  }

  if (size) {
    classes.push(`w-${size / 2} h-${size / 2}`);
  }

  const hasIconAndText = icon && rest.children;

  return (
    <button {...rest} className={`flex ${classes.join(' ')}`} style={style}>
      <div className={`flex items-center ${hasIconAndText ? 'space-x-1' : ''}`}>
        {icon && iconPosition === 'left' && <Icon icon={icon} />}
        <div className="whitespace-nowrap">{rest.children}</div>
        {icon && iconPosition === 'right' && <Icon icon={icon} />}
      </div>
    </button>
  );
}

export default Button;
